module.exports = __webpack_public_path__ + "07bb7d5531aed00c1ea0fbc630ac4372.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/product-promo-mobile.png
// module id = 191
// module chunks = 0